module.exports = __webpack_public_path__ + "img/y11.3225acab.jpg";